module.exports = __webpack_public_path__ + "img/bobide_bobocoin.gm.ab41317.png";